module.exports = __webpack_public_path__ + "media/alert.5a21acdf.mp3";